"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _themeProvider = require("@dbi-tools/ui-kit/lib/components/theme-provider");

var _uiKit = require("@dbi-tools/ui-kit");

var _useMedia = require("../../hooks/use-media");

var _useStyles = require("../../hooks/useStyles");

var _useElementProps = require("../../hooks/use-element-props");

var _themeOptions = require("../../helpers/theme-options");

var _const = require("../../const");

var _helpers = require("../../helpers");

var _headerTitles = require("../header-titles");

var _pairedView = require("./templates/paired-view");

var _notPairedView = require("./templates/not-paired-view");

var _scrollView = require("./templates/scroll-view");

var _carouselView = require("./templates/carousel-view");

var _const2 = require("./const");

var _style = _interopRequireDefault(require("./style"));

var _photoLayout = require("./photo-layout.styled");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// TODO refactor code
var PhotoLayout = function PhotoLayout(_ref) {
  var _ref$theme = _ref.theme,
      currentTheme = _ref$theme === void 0 ? _themeOptions.ThemeVariants.WHITE : _ref$theme,
      id = _ref.id,
      headline1 = _ref.headline1,
      headline2 = _ref.headline2,
      description = _ref.description,
      _ref$mobileLayout = _ref.mobileLayout,
      mobileLayout = _ref$mobileLayout === void 0 ? _const.MobileLayouts.SCROLL : _ref$mobileLayout,
      removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding,
      _ref$buttons = _ref.buttons,
      buttons = _ref$buttons === void 0 ? [] : _ref$buttons,
      rest = _objectWithoutProperties(_ref, ["theme", "id", "headline1", "headline2", "description", "mobileLayout", "removeTopPadding", "removeBottomPadding", "buttons"]);

  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color,
      type = _themeStrategy$curren.type,
      size = _themeStrategy$curren.size;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isHalfTheme = size === _themeOptions.ThemeSize.HALF;
  var isCroppedTheme = size === _themeOptions.ThemeSize.CROPPED;

  var getImages = function getImages() {
    var imageArr = [];

    for (var i = 1; i <= 5; i++) {
      // @ts-ignore
      var imgRef = rest["fileReference".concat(i)]; // @ts-ignore

      var imgAtlText = rest["altText".concat(i)]; // @ts-ignore

      var imgLink = rest["imageLink".concat(i)];
      imgRef && imageArr.push({
        fileReference: imgRef,
        // @ts-ignore
        link: rest["link".concat(i)],
        // @ts-ignore
        linkTitle: rest["linkTitle".concat(i)],
        imageText: i === 2 ? rest.imageText2 : '',
        headline1: i === 3 ? rest.scriptHeadline : '',
        headline2: i === 3 ? rest.sansSerifHeadline : '',
        altText: imgAtlText && imgAtlText,
        imageLink: imgLink
      });
    }

    return imageArr;
  };

  var images = getImages();
  var btnColor = (0, _helpers.getButtonColorByTheme)(isDarkTheme);
  var isPairedItems = images.length % 2 === 0;
  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var isTablet = (0, _useMedia.useMedia)(_const.Breakpoints.TABLET);
  var isDesktop = (0, _useMedia.useMedia)(_const.Breakpoints.DESKTOP);
  var paddingSize = isMobile ? _const.MOBILE_PADDING_SIZE : _const.DEFAULT_PADDING_SIZE;
  var bottomPadding = removeBottomPadding ? 0 : paddingSize;
  var topPadding = removeTopPadding ? 0 : paddingSize;
  var containerPadding = [topPadding, 0, bottomPadding];
  var isScrollView = mobileLayout === _const.MobileLayouts.SCROLL;
  /*
   *   backdrop
   * */
  // back drop for cases if we have 3 images (dropOffsetRef + dropInBetweenRef) and if more than 3 images (dropOffsetRef + dropInFullRef)

  var containerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dropOffsetRef = _useState2[0],
      setDropOffsetRef = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      dropInBetweenRef = _useState4[0],
      setDropInBetween = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      dropInFullRef = _useState6[0],
      setDropInFullRef = _useState6[1];

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      dropOffsetState = _useState8[0],
      setDropOffsetState = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      dropRightOffsetState = _useState10[0],
      setDropRightOffsetState = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      dropHeightState = _useState12[0],
      setDropHeightState = _useState12[1];

  var updateValuesDesktop = function updateValuesDesktop() {
    var offset = (0, _useElementProps.useElementProps)(dropOffsetRef).top - (0, _useElementProps.useElementProps)(containerRef).top + (0, _useElementProps.useElementProps)(dropOffsetRef).height;
    var offsetCropped = (0, _useElementProps.useElementProps)(dropOffsetRef).top - (0, _useElementProps.useElementProps)(containerRef).top + (0, _useElementProps.useElementProps)(dropOffsetRef).height;
    var notPairedOffset = offset - (images.length > _const2.DEVICE_RENDER_ITEMS ? _const2.BACKDROP_IMAGE_LARGE_OFFSET : _const2.BACKDROP_IMAGE_SMALL_OFFSET);
    var pairedOffset = isCroppedTheme ? offsetCropped - _const2.BACKDROP_IMAGE_SMALL_OFFSET : offset + _const2.BACKDROP_IMAGE_LARGE_OFFSET;
    var inBetweenHeight = (0, _useElementProps.useElementProps)(dropInBetweenRef).bottom - (0, _useElementProps.useElementProps)(containerRef).top - notPairedOffset;

    var inBetweenHeightCropped = (0, _useElementProps.useElementProps)(dropInBetweenRef).top - (0, _useElementProps.useElementProps)(containerRef).top - notPairedOffset + _const2.BACKDROP_IMAGE_SMALL_OFFSET;

    var inFullHeight = (0, _useElementProps.useElementProps)(dropInFullRef).top - (0, _useElementProps.useElementProps)(containerRef).top - notPairedOffset + _const2.BACKDROP_IMAGE_SMALL_OFFSET;

    var notPairedHeight = images.length > _const2.DEVICE_RENDER_ITEMS ? inFullHeight : inBetweenHeight + _const2.BACKDROP_IMAGE_LARGE_OFFSET;
    var pairedHeight = isCroppedTheme ? inBetweenHeightCropped : inBetweenHeight - _const2.BACKDROP_IMAGE_LARGE_OFFSET;
    setDropOffsetState(isPairedItems ? pairedOffset : notPairedOffset);
    setDropRightOffsetState(isPairedItems ? _const2.BACKDROP_IMAGE_LARGE_OFFSET : (0, _useElementProps.useElementProps)(dropOffsetRef).left - (0, _useElementProps.useElementProps)(dropOffsetRef).width);
    setDropHeightState(isPairedItems ? pairedHeight : notPairedHeight);
  };

  var updateValuesDevice = function updateValuesDevice() {
    var offset = (0, _useElementProps.useElementProps)(dropOffsetRef).top - (0, _useElementProps.useElementProps)(containerRef).top + (0, _useElementProps.useElementProps)(dropOffsetRef).height / (isMobile ? _const2.BACKDROP_MOBILE_SLICER : _const2.BACKDROP_DEVICE_SLICER);
    var inBetweenHeight = (0, _useElementProps.useElementProps)(containerRef).bottom - offset;
    setDropOffsetState(offset);
    setDropHeightState(inBetweenHeight);
  };

  (0, _react.useEffect)(function () {
    var func = function func() {
      return isMobile || images.length > _const2.DEVICE_RENDER_ITEMS && isTablet ? updateValuesDevice() : updateValuesDesktop();
    };

    var handleResize = (0, _lodash.debounce)(function () {
      return func();
    }, 200);
    window.addEventListener('resize', handleResize);
    func();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [dropOffsetRef, dropInBetweenRef, dropInFullRef]);
  /*
   *   end backdrop
   * */

  var basicStyles = (0, _useStyles.useStyles)('a', _style.default);
  var theme = {
    $theme: currentTheme,
    $styles: basicStyles,
    $dropOffset: dropOffsetState,
    $dropRightOffset: isCroppedTheme && !isTablet ? dropRightOffsetState : 0,
    $dropHeight: dropHeightState,
    $setBgToBottom: images.length < 4
  };

  var desktopView = function desktopView() {
    var component = [];
    var chunk = isPairedItems ? _const2.PAIRED_CHUNK_SIZE : _const2.NOT_PAIRED_CHUNK_SIZE;

    for (var i = 0; i < images.length; i += chunk) {
      var slicedImages = images.slice(i, i + chunk);
      component.push(isPairedItems ? /*#__PURE__*/_react.default.createElement(_pairedView.PairedView, _extends({
        key: i
      }, {
        images: slicedImages,
        headline1Color: headline1Color,
        headline2Color: headline2Color,
        btnColor: btnColor,
        isTablet: isTablet,
        isHalfTheme: isHalfTheme,
        isDarkTheme: isDarkTheme,
        isCroppedTheme: isCroppedTheme,
        setDropOffsetRef: setDropOffsetRef,
        setDropInBetween: setDropInBetween
      })) : /*#__PURE__*/_react.default.createElement(_notPairedView.NotPairedView, _extends({
        key: i
      }, {
        images: slicedImages,
        headline1Color: headline1Color,
        headline2Color: headline2Color,
        btnColor: btnColor,
        isTablet: isTablet,
        isDesktop: isDesktop,
        isHalfTheme: isHalfTheme,
        isDarkTheme: isDarkTheme,
        isCroppedTheme: isCroppedTheme,
        setDropOffsetRef: setDropOffsetRef,
        setDropInBetween: setDropInBetween,
        setDropInFullRef: setDropInFullRef
      })));
    }

    return component;
  };

  var deviceView = function deviceView() {
    var template = isScrollView ? /*#__PURE__*/_react.default.createElement(_scrollView.ScrollView, {
      images: images,
      isMobile: isMobile,
      btnColor: btnColor,
      isScrollView: isScrollView,
      headline1Color: headline1Color,
      headline2Color: headline2Color,
      setDropOffsetRef: setDropOffsetRef
    }) : /*#__PURE__*/_react.default.createElement(_carouselView.CarouselView, {
      images: images,
      isMobile: isMobile,
      isTablet: isTablet,
      btnColor: btnColor,
      isScrollView: isScrollView,
      headline1Color: headline1Color,
      headline2Color: headline2Color,
      setDropOffsetRef: setDropOffsetRef,
      isHalfTheme: isHalfTheme
    });
    return images.length > _const2.DEVICE_RENDER_ITEMS || isMobile ? template : /*#__PURE__*/_react.default.createElement(_notPairedView.NotPairedView, {
      images: images.slice(0, _const2.DEVICE_RENDER_ITEMS),
      headline1Color: headline1Color,
      headline2Color: headline2Color,
      btnColor: btnColor,
      isTablet: isTablet,
      isDesktop: isDesktop,
      isHalfTheme: isHalfTheme,
      isDarkTheme: isDarkTheme,
      isCroppedTheme: isCroppedTheme,
      setDropOffsetRef: setDropOffsetRef,
      setDropInBetween: setDropInBetween,
      setDropInFullRef: setDropInFullRef
    });
  };

  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_photoLayout.StyledBox, {
    ref: containerRef,
    p: containerPadding,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_PHOTO_LAYOUT,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: isHalfTheme ? 'primaryDark' : headline1Color,
    headline2Color: isHalfTheme ? 'gray800' : headline2Color
  }), (headline1 || headline2 || description) && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    mt: {
      xs: 30,
      md: 45
    }
  }), /*#__PURE__*/_react.default.createElement(_themeProvider.GridThemeProvider, {
    gridTheme: {
      gridColumns: 24
    }
  }, /*#__PURE__*/_react.default.createElement(_photoLayout.ContainerStyled, {
    noPadding: (isTablet || isMobile) && isScrollView
  }, isDesktop ? desktopView() : deviceView())), !!buttons.length && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    mt: 45,
    color: isCroppedTheme && isDarkTheme && !isMobile || isHalfTheme && isDarkTheme && !isMobile ? 'gray800' : (0, _helpers.getButtonColorByTheme)(isDarkTheme)
  })));
};

var _default = PhotoLayout;
exports.default = _default;